<template>
  <v-container>
    <!-- Banner promocional (grupo por cantidad y/o forma de pago) -->
    <promo-banner :grupo-id="grupoIdProductos"></promo-banner>

    <v-row class="mt-4" v-show="!loading">
      <v-col v-for="(p,i) in products" :key="`${p.id}_${i}`" cols="3">
        <categoria-product-card :product="p"></categoria-product-card>
      </v-col>
    </v-row>
    <v-row class="mt-4" v-if="loading">
      <v-col v-for="i in 8" cols="3" :key="`${i}ab`">
        <v-skeleton-loader
            type="image, actions"
            :loading="loading">
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import CategoriaProductCard from './cards/CategoriaProductCard.vue'
import PromoBanner from './PromoBanner.vue'

export default {
  name: 'ProductosList',
  components: {
    CategoriaProductCard,
    PromoBanner
  },
  computed: {
    ...mapState('Categorias', ['currentCategoria']),
    grupoIdProductos () {
      // Obtener el GrupoId del primer producto que tenga GrupoDescuento
      if (this.products && this.products.length > 0) {
        const productoConGrupo = this.products.find(p => p.GrupoDescuento && p.GrupoDescuento.GrupoId)
        return productoConGrupo ? productoConGrupo.GrupoDescuento.GrupoId : null
      }
      return null
    }
  },
  methods: {
    ...mapActions('Productos', ['fetchProducts'])
  },
  data () {
    return {
      loading: false,
      products: []
    }
  },
  watch: {
    async currentCategoria (newVal, old) {
      this.loading = true
      this.products = await this.fetchProducts(newVal)
      this.loading = false
    }
  }
}
</script>
